// extracted by mini-css-extract-plugin
export default {"title":"SecurityChapter-module--title--af69c"};